import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-radiologia',
  templateUrl: './radiologia.component.html',
  styleUrls: ['./radiologia.component.css']
})
export class RadiologiaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
